import React from "react";
import CustomDropdownComponent from "./custom-dropdown.component";
import { ICustomDropdown } from "./types";

const CustomDropdownContainer = (props: ICustomDropdown) => {
  return <CustomDropdownComponent {...props} />;
};

export default CustomDropdownContainer;
